import { Navigate, useLocation } from "react-router-dom";
import { isLoggedIn, isStaff, isSuperUser } from "../utils/auth";

export default function StaffRoute({ children, authReady }) {
  const location = useLocation();

  if (!authReady) {
    return <div>Loading...</div>;
  }

  if (!isLoggedIn()) {
    return <Navigate to="/admin/login" replace state={{ from: location.pathname }} />;
  }

  if (!isStaff() && !isSuperUser()) {
    return <Navigate to="/401" replace />;
  }

  return children;
}